import { SectionCardInterface } from "./interfaces/SectionCardInterface";

export const INSPECTIONS_CARDS: Array<SectionCardInterface> = [
    {
        title: 'titulo izq arriba',
        content: 'contenido',
        imgLink: 'assets/inspections-card-1.jpg',
        link: '#',
    },
    {
        title: 'titulo der arriba',
        content: 'contenido',
        imgLink: 'assets/inspections-card-1.jpg',
        link: '#',
    },
    {
        title: 'titulo izq abajo',
        content: 'contenido',
        imgLink: 'assets/inspections-card-1.jpg',
        link: '#',
    },
    {
        title: 'titulo der abajo',
        content: 'contenido',
        imgLink: 'assets/inspections-card-1.jpg',
        link: '#',
    },
]

